import { useContext } from 'react'

import { SettingsContext } from '@/contexts/settings'
import type { SettingsContextValue } from '@/contexts/settings'

export function useSettings(): SettingsContextValue {
	const context = useContext(SettingsContext)

	if (!context) {
		throw new Error('useSettings must be used within a SettingsProvider')
	}

	return context
}
